module.exports = __webpack_public_path__ + "media/images/district_m_small_logo-45b56ea5c2df047dded36a0ec3faafbe.png";